<template>
  <div class="mb-6" :class="{ 'px-2': !isDesktop }">
    <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <h1 class="text-[30px] text-grey-light-900 font-semibold">{{ title }}</h1>
      <div class="w-full md:w-[200px] md:ml-auto">
        <Select :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
          <SelectTrigger class="w-full">
            <SelectValue :placeholder="placeholder" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem v-for="option in options" :key="option.value" :value="option.value">
              {{ option.label }}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useBreakpoint } from '@/utils/useBreakPoint';

interface FilterOption {
  value: string;
  label: string;
}

interface Props {
  title: string;
  modelValue: string;
  options: FilterOption[];
  placeholder?: string;
}

const { isDesktop } = useBreakpoint();

defineProps<Props>();
defineEmits<{
  'update:modelValue': [value: string];
}>();
</script>
